import { Router } from '@angular/router';
export class Utils {
  static encodeSpecialCharacters(str: string) {
    if (!str) return;
    // check https://github.com/angular/angular/issues/11058
    // 	to encode more special characters
    return str.replace(/\+/gi, '%2B').replace(/\//gi, '%2F');
  }

  static mapBase64Image(base64Image: string | undefined): string {
    if (!base64Image?.length) return '';
    return `data:image/png;base64, ${base64Image}`;
  }

  static navigateToTop(section?: string) {
    section = section || 'TOP';

    setTimeout(() => {
      const element = document.getElementById(section!);

      if (element) {
        const headerOffset = 100;

        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }, 300);
  }
}
